import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './routes';
import { ErrorBoundary } from './ErrorBoundary';
import { CookieConsentBanner } from '@/components/organisms/CookieConsentBanner';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 } },
});

export const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <CookieConsentBanner />
    </QueryClientProvider>
  </ErrorBoundary>
);
